export default __webpack_public_path__ + "static/media/servicehome.f111ab84.png";